import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';
import RightSlider from 'component/hoc/rightSlider/RightSlider';
import ResponseAiForm from 'component/organism/workflow/forms/response-ai/ResponseAiForm';
import { FormikProvider, useFormik } from 'formik';
import { isEqual } from 'lodash';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import * as Yup from 'yup';

const ResponseAiModal = ({
  knowledgeBaseData,
  isOpen,
  onClose,
  title,
  id,
  isLoading,
  isError,
}) => {
  const {
    workflowData,
    setWorkflowData,
    selectedNode,
    initialWorkflowData,
    setIsChanged,
  } = useWorkflowContext();
  const [init, setInit] = useState({});
  useEffect(() => {
    setInit({
      question:
        selectedNode?.responseAi?.question == '' ||
        selectedNode?.responseAi?.question == undefined
          ? '<p>{last_user_input}</p>'
          : selectedNode?.responseAi?.question,
      aiMaterials: selectedNode?.responseAi?.aiMaterials?.length
        ? selectedNode.responseAi.aiMaterials.map(
            (m) => m.materialId || m.folderId
          )
        : ['all'],

      promptDescription: selectedNode?.responseAi?.promptDescription || '',
      responseThemeId: selectedNode?.responseAi?.responseThemeId || '',
      outputVariableId: selectedNode?.responseAi?.outputVariableId || '',
    });
  }, [selectedNode]);
  const formik = useFormik({
    initialValues: init,
    enableReinitialize: true,
    validationSchema: Yup.object({
      question: Yup.string().required('Question is required'),
      aiMaterials: Yup.array().min(1, 'At least one material is required'),
      promptDescription: Yup.string(),
      responseThemeId: Yup.string().required('Response Theme is required'),
      outputVariableId: Yup.string().required('Variable is required'),
    }),
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const initialNode = initialWorkflowData?.find((node) => node?.id === id);
      if (initialNode) {
        const {
          aiMaterials,
          promptDescription,
          responseThemeId,
          question,
          outputVariableId,
        } = initialNode?.responseAi || {};
        const initialMessageObject = {
          aiMaterials: aiMaterials?.length
            ? aiMaterials?.map((m) => m.materialId || m.folderId)
            : ['all'],
          question:
            question == '' || question == undefined
              ? '<p>{last_user_input}</p>'
              : question,
          promptDescription,
          responseThemeId,
          outputVariableId,
        };
        const currentValues = values;
        const changed = !isEqual(currentValues, initialMessageObject);
        setIsChanged((prev) => {
          const alreadyExists = prev?.includes(id);
          if (changed && !alreadyExists) {
            return [...prev, id];
          }
          if (!changed && alreadyExists) {
            return prev?.filter((nodeId) => nodeId !== id);
          }

          return prev;
        });
      }
    },
  });
  const initialNode = initialWorkflowData?.find((node) => node?.id === id);

  const handleSubmit = async () => {
    await formik.handleSubmit();
    try {
      setTimeout(() => {
        const validMaterials = formik.values.aiMaterials
          .map((materialId) => {
            const matchedItem = knowledgeBaseData?.data?.items?.find(
              (val) => val.companyMaterialId === materialId
            );
            return matchedItem
              ? matchedItem.isFolder
                ? { folderId: matchedItem.companyMaterialId }
                : { materialId: matchedItem.companyMaterialId }
              : null;
          })
          .filter(Boolean);

        const updatedValues = {
          ...formik.values,
          aiMaterials: validMaterials,
        };

        formik.setSubmitting(false);

        const updatedNodes = workflowData?.nodes?.map((node) =>
          node.id === id
            ? { ...node, responseAi: updatedValues, is_Error: isError }
            : node
        );

        setWorkflowData((prev) => ({
          ...prev,
          nodes: updatedNodes,
        }));

        onClose();
        formik.resetForm();
      }, [100]);
    } catch {
      toast.error('Something went wrong');
    }
  };

  useEffect(() => {
    const updatedNodes = workflowData?.nodes?.map((node) =>
      node.id === id ? { ...node, is_Error: isError } : node
    );

    setWorkflowData((prev) => ({
      ...prev,
      nodes: updatedNodes,
    }));
  }, [isError]);

  useEffect(() => {
    if (isError) {
      formik.handleSubmit();
    }
  }, [isOpen]);

  return (
    <RightSlider
      title={title}
      action={{
        isOpen: isOpen,
        setIsOpen: handleSubmit,
      }}
    >
      <FormikProvider value={formik}>
        <ResponseAiForm
          knowledgeBaseData={knowledgeBaseData}
          isLoading={isLoading}
          workflowData={workflowData}
        />
      </FormikProvider>
    </RightSlider>
  );
};

export default ResponseAiModal;
